"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:no-console */
var ReportEventUnauthenticatedParams_1 = require("./ReportEventUnauthenticatedParams");
var FetchRequester_1 = require("./FetchRequester");
var TelemetryForwarder = /** @class */ (function () {
    function TelemetryForwarder(endpoint, isPublicGuest) {
        if (endpoint === void 0) { endpoint = TelemetryForwarder.defaultEndpoint; }
        if (isPublicGuest === void 0) { isPublicGuest = false; }
        this.isVizportal = endpoint === TelemetryForwarder.defaultEndpoint;
        this.requester = new FetchRequester_1.FetchRequester(this.getEndpoint(endpoint, isPublicGuest));
    }
    TelemetryForwarder.prototype.send = function (reportEventUnauthenticatedParams) {
        this.requester.send(reportEventUnauthenticatedParams);
    };
    TelemetryForwarder.prototype.buildTelemetryAndSend = function (eventType, serviceName, properties) {
        // Vizportal sets the 'pod' property for events sent to it. If we're sending elsewhere,
        // the client needs to set that value itself
        if (!this.isVizportal) {
            properties[TelemetryForwarder.podIndex] = document.domain;
        }
        this.requester.send(ReportEventUnauthenticatedParams_1.createReportEventUnauthenticatedParams(eventType, serviceName, properties));
    };
    TelemetryForwarder.prototype.getEndpoint = function (endpoint, isPublicGuest) {
        if (!isPublicGuest) {
            return endpoint;
        }
        switch (document.domain) {
            case 'public.tableau.com': {
                return 'https://prod.telemetry.tableausoftware.com';
            }
            case 'public-stage.tableau.com': {
                return 'https://stage.telemetry.tableausoftware.com';
            }
            default: {
                return 'https://qa.telemetry.tableausoftware.com';
            }
        }
    };
    TelemetryForwarder.defaultEndpoint = '';
    TelemetryForwarder.podIndex = 'pod_name';
    return TelemetryForwarder;
}());
exports.TelemetryForwarder = TelemetryForwarder;
//# sourceMappingURL=TelemetryForwarder.js.map